import { addProperty, noop } from './utils';

// var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

var fn = (() => {
   var val;
   var valLength;

   var fnMap = [
      [
         'requestFullscreen',
         'exitFullscreen',
         'fullscreenElement',
         'fullscreenEnabled',
         'fullscreenchange',
         'fullscreenerror'
      ],
      // new WebKit
      [
         'webkitRequestFullscreen',
         'webkitExitFullscreen',
         'webkitFullscreenElement',
         'webkitFullscreenEnabled',
         'webkitfullscreenchange',
         'webkitfullscreenerror'

      ],
      // old WebKit (Safari 5.1)
      [
         'webkitRequestFullScreen',
         'webkitCancelFullScreen',
         'webkitCurrentFullScreenElement',
         'webkitCancelFullScreen',
         'webkitfullscreenchange',
         'webkitfullscreenerror'

      ],
      [
         'mozRequestFullScreen',
         'mozCancelFullScreen',
         'mozFullScreenElement',
         'mozFullScreenEnabled',
         'mozfullscreenchange',
         'mozfullscreenerror'
      ],
      [
         'msRequestFullscreen',
         'msExitFullscreen',
         'msFullscreenElement',
         'msFullscreenEnabled',
         'MSFullscreenChange',
         'MSFullscreenError'
      ]
   ];

   var i = 0;
   var l = fnMap.length;
   var ret = {};

   for (; i < l; i++) {
      val = fnMap[i];
      if (val && val[1] in document) {
         for (i = 0, valLength = val.length; i < valLength; i++) {
            ret[fnMap[0][i]] = val[i];
         }
         return ret;
      }
   }

   return false;
})();

const screenfull = {
   request(elem) {
      var request = fn.requestFullscreen;

      elem = elem || document.documentElement;

      // Work around Safari 5.1 bug: reports support for
      // keyboard in fullscreen even though it doesn't.
      // Browser sniffing, since the alternative with
      // setTimeout is even worse.
      if (/5\.1[\.\d]* Safari/.test(navigator.userAgent)) {
         elem[request]();
      } else {
         elem[request]();
         // keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT
      }
   },
   exit() {
      if (this.isFullscreen) {
         document[fn.exitFullscreen]();
      }
   },
   toggle(elem) {
      if (this.isFullscreen) {
         this.exit();
      } else {
         this.request(elem);
      }
   },
   raw: fn
};

addProperty(screenfull, 'isFullscreen', isFullscreen, noop);
addProperty(screenfull, 'element', element, noop);
addProperty(screenfull, 'enabled', enabled, noop);

export default fn ? screenfull : false;

function isFullscreen() {
   return Boolean(document[fn.fullscreenElement]);
}

function element() {
   return document[fn.fullscreenElement];
}

function enabled() {
   return Boolean(document[fn.fullscreenEnabled]);
}
